import { array } from 'fp-ts';
import { Restriction } from '@mews-commander/data-access';
import { CellStatus } from './enums';

interface CellStatusParams {
    cellRestrictions: Restriction[];
    hasExceptions: boolean;
    hasOpenHoursIntervals: boolean;
}

const getCellStatus = ({ cellRestrictions, hasExceptions, hasOpenHoursIntervals }: CellStatusParams) => {
    if (!array.isEmpty(cellRestrictions) && !hasExceptions && !hasOpenHoursIntervals) {
        return CellStatus.Closed;
    }
    if (array.isEmpty(cellRestrictions) && !hasExceptions && !hasOpenHoursIntervals) {
        return CellStatus.Open;
    }
    return CellStatus.Exceptions;
};

export default getCellStatus;
